export const queryKeys = {
  EXCEL_CONSTRUCTOR_GENERATE_COUNT: 'EXCEL_CONSTRUCTOR_GENERATE_COUNT'
};
